import { Card, CardContent } from "@/components/ui/card";
import { TabsContent } from "@/components/ui/tabs";
import { userEventNotificationPreferenceService } from "@/services/api/userEventNotificationPreferences";
import { NotificationPreferencesTable } from "../UserEventNotificationPreferences/NotificationPreferencesTable";

interface UserNotificationsTabProps {
  userId: number | null;
}

const UserNotificationsTab = ({ userId }: UserNotificationsTabProps) => {
  if (!userId) {
    return (
      <TabsContent value="notifications" className="space-y-6 mt-4">
        <Card>
          <CardContent className="p-6 text-sm text-muted-foreground">
            Salve o usuário antes de configurar as preferências de notificação.
          </CardContent>
        </Card>
      </TabsContent>
    );
  }

  return (
    <TabsContent value="notifications" className="space-y-6 mt-4">
      <NotificationPreferencesTable
        queryKey={["user-notification-preferences", userId]}
        fetchPreferences={() =>
          userEventNotificationPreferenceService.indexForUser(userId)
        }
        updatePreferences={(data) =>
          userEventNotificationPreferenceService.updateForUser(userId, data)
        }
      />
    </TabsContent>
  );
};

export default UserNotificationsTab;
